import { HardTermination } from '../shared';

export const NotAMinorTermination = () => (
  <HardTermination
    title="We require patients 18 and older to take the assessment themselves"
    body="Please go back and have the patient fill out the assessment using their information."
  />
);
